import { FieldCreatedEvent } from '../event/field-created.event';
const fieldCreatedProjections = {
    [FieldCreatedEvent.name]: (event, state) => ({
        ...state,
        ...event.getPayload(),
    }),
};
export default fieldCreatedProjections;
//# sourceMappingURL=field-created.projection.js.map